import { Message } from 'element-ui';

// 复制链接
const copyLink = async (textToCopy = '') => {
  // 优先使用现代 Clipboard API
  if (navigator.clipboard && navigator.clipboard.writeText) {
    try {
      await navigator.clipboard.writeText(textToCopy);
      Message.success('复制成功！');
    } catch (err) {
      Message.error('复制失败，请手动复制');
      fallbackCopy(textToCopy); // 尝试降级方案
    }
  } else {
    // 不支持 Clipboard API，使用降级方案
    fallbackCopy(textToCopy);
  }
}

// 降级复制方案 (使用 textarea 和 execCommand)
const fallbackCopy = (text) => {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  // 隐藏 textarea
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  textarea.style.pointerEvents = 'none';
  document.body.appendChild(textarea);
  textarea.select();
  try {
    const successful = document.execCommand('copy');
    if (successful) {
      Message.success('复制成功！');
    } else {
      Message.error('复制失败，请手动复制');
    }
  } catch (err) {
    Message.error('复制失败，请手动复制');
  } finally {
    document.body.removeChild(textarea);
  }
}

export default copyLink

